// extracted by mini-css-extract-plugin
export default {"container":"rWXue_","updatedCheckoutSummary":"kQAvTG","left":"rIhyE1","leftUpdatedCheckoutSummary":"qsQD53","right":"reqvJS","rightUpdatedCheckoutSummary":"JzlhLe"};